<template>
  <path
    d="M20 4.00018H4C2.89 4.00018 2.01 4.89018 2.01 6.00018L2 18.0002C2 19.1102 2.89 20.0002 4 20.0002H20C21.11 20.0002 22 19.1102 22 18.0002V6.00018C22 4.89018 21.11 4.00018 20 4.00018ZM19 18.0002H5C4.45 18.0002 4 17.5502 4 17.0002V12.0002H20V17.0002C20 17.5502 19.55 18.0002 19 18.0002ZM20 8.00018H4V6.00018H20V8.00018Z"
  />
</template>
